
import { Route, Routes } from "react-router";
import Delivery from "./Delivery";
import List from "./List";


export default function Deliveries() {

   return <Routes>
      <Route path='/' element={<List />} />
      <Route path='/:id' element={<Delivery />} />
   </Routes>
}